/**
 * DocumentsTab Component
 * Manages organization document library (waivers, medical forms, etc.)
 */
import "./documentsProductsAthletic.css";
import { Button } from "../../components/ui/button";
import { Plus, Edit, Trash2, FileText } from "lucide-react";

const DocumentsTab = ({ 
  documents, 
  setEditingDoc,
  setDocData,
  setDocDialogOpen,
  handleDeleteDocument
}) => {
  const handleAddDocument = () => {
    setEditingDoc(null);
    setDocData({ name: "", type: "waiver", content: "" });
    setDocDialogOpen(true);
  };

  const handleEditDocument = (doc) => {
    setEditingDoc(doc);
    setDocData({ name: doc.name, type: doc.type, content: doc.content });
    setDocDialogOpen(true);
  };

  return (
    <div className="sh-documents-products" data-testid="documents-tab">
      <div className="operational-panel">
        <div className="operational-header">
          <div>
            <h2 className="operational-heading">Document Library</h2>
            <p className="text-sm text-slate-500">
              Create reusable documents for your programs (waivers, medical forms, etc.)
            </p>
          </div>
          <Button
            onClick={handleAddDocument}
            className="operational-primary"
            data-testid="add-document-btn"
          >
            <Plus className="w-4 h-4 mr-2" />
            Add Document
          </Button>
        </div>

        {documents.length > 0 ? (
          <div className="operational-list">
            {documents.map((doc) => (
              <div key={doc.doc_id} className="operational-row" data-testid={`document-${doc.doc_id}`}>
                <div className="operational-row-content">
                  <div className="operational-identity">
                    <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center">
                      <FileText className="w-5 h-5 text-slate-600" />
                    </div>
                    <div>
                      <p className="font-medium text-slate-900">{doc.name}</p>
                      <p className="text-sm text-slate-500 capitalize">{doc.type}</p>
                    </div>
                  </div>
                  <div className="operational-actions">
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => handleEditDocument(doc)}
                      aria-label={`Edit ${doc.name}`}
                      data-testid={`edit-document-${doc.doc_id}`}
                    >
                      <Edit className="w-4 h-4" />
                    </Button>
                    <Button
                      variant="ghost"
                      size="sm"
                      className="text-red-600 hover:text-red-700"
                      onClick={() => handleDeleteDocument(doc.doc_id)}
                      aria-label={`Delete ${doc.name}`}
                      data-testid={`delete-document-${doc.doc_id}`}
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <FileText className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <p className="text-slate-500 mb-4">No documents yet. Create your first document.</p>
            <Button
              onClick={handleAddDocument}
              variant="outline"
              className="border-slate-300 rounded-full"
            >
              Create Document
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentsTab;
